<template>
  <div class="page-main">
    <div class="page-top">page-top</div>
    <div class="page-cont clearfix">
      <div class="page-left">page-left</div>
      <div class="page-right">page-right</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.page-main {
  .page-top,
  .page-left,
  .page-right {
    padding: 10px;
    background: #f8f8f8;
    border: 1px solid @colorGrayD;
  }
  .page-cont {
    margin-top: 10px;
    .page-left {
      float: left;
      width: 180px;
    }
    .page-right {
      margin-left: 210px;
    }
  }
}
</style>
